import React, { PropTypes, Component } from 'react';
import Helmet from 'react-helmet';
import _ from 'underscore';

import RegisterParentInviteForm from '../forms/RegisterParentInviteForm';
import RegisterParentForm from '../forms/RegisterParentForm';
import RegisterSchoolForm from '../forms/RegisterSchoolForm';

class RegisterPage extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isParent: false,
            isParentInfo: false,
            isSchool: false
        };
    }

    componentDidUpdate() {
        const { auth } = this.props;
        const { isParent, isParentInfo } = this.state;

        if (!_.isNull(auth.selectedSchool) && isParent && !isParentInfo) {
            this.toggleParentInfo();
        }
    }

    toggleParent = () => {
        this.setState({ isParent: true, isSchool: false, isParentInfo: false });
    };

    toggleParentInfo = () => {
        this.setState({ isParent: true, isSchool: false, isParentInfo: true });
    };

    toggleSchool = () => {
        this.setState({ isSchool: true, isParent: false, isParentInfo: false });
    };

    renderParent() {
        const { actions, auth } = this.props;
        const { isParentInfo } = this.state;

        return (
            <div>
                {isParentInfo ?
                    <div className="login-block" id="parent-account-form">
                        <div className="title">
                            <h2>Register for a parent account</h2>
                            <p>Not a parent? Click here to <a onClick={this.toggleSchool} className="link-register-parent">register as a school</a></p>
                        </div>
                        <RegisterParentForm selectedSchool={auth.selectedSchool} handleSubmit={actions.signupRequest} />
                    </div>
                :
                    <div className="login-block" id="parent-account-invite-code">
                        <div className="title">
                            <h2>ENTER INVITATION CODE</h2>
                            <p>Please enter the invitation code provided to you by your school.</p>
                            <p>Not a parent? Click here to <a onClick={this.toggleSchool} className="link-register-parent">register as a school</a></p>
                        </div>
                        <RegisterParentInviteForm handleSubmit={actions.signupSchoolSearchRequest} />
                    </div>
                }
            </div>
        );
    }

    renderSchool() {
        const { actions } = this.props;

        return (
            <div className="login-block" id="school-account">
                <div className="title">
                    <h2>Register for a school account</h2>
                    <p>Not a school? Click here to <a onClick={this.toggleParent} className="link-register-parent">register as a parent</a></p>
                </div>
                <RegisterSchoolForm handleSubmit={actions.signupRequest} />
            </div>
        );
    }

    render() {
        const { isSchool, isParent, isParentInfo } = this.state;

        return (
            <div className="register-wrapper index-1">
                <Helmet title="Register" />
                <div className="inner">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-5 title-area">
                                <h2>Free storybooks and resources for primary schools.</h2>
                                <ul className="ct-list icon-list">
                                    <li><i className="fa fa-book" /> Books for guided reading</li>
                                    <li><i className="fa fa-graduation-cap" /> Enterprise education</li>
                                    <li><i className="fa fa-comment" /> Discussion topics</li>
                                    <li><i className="fa fa-map-o" /> PSHE lesson plans</li>
                                    <li><i className="fa fa-calendar" /> Book your free enterprise session</li>
                                    <li><i className="fa fa-calendar-plus-o" /> More resources added monthly</li>
                                </ul>
                            </div>

                            <div className="col-md-7">
                                {!isParent && !isParentInfo && !isSchool ?
                                    <div className="login-block select-type row" id="account-type-select">
                                        <h2>Please select your account type</h2>
                                        <div className="col-md-6">
                                            <button id="btn-register-parent" onClick={this.toggleParent}><i className="fa fa-user" /> Register as a parent</button>
                                        </div>
                                        <div className="col-md-6">
                                            <button id="btn-register-school" onClick={this.toggleSchool}><i className="fa fa-institution" /> Register as a School</button>
                                        </div>
                                    </div>
                                    : null}

                                {isSchool ? this.renderSchool() : null}
                                {isParent ? this.renderParent() : null}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RegisterPage.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object
};

export default RegisterPage;



/** WEBPACK FOOTER **
 ** ./src/pages/RegisterPage.js
 **/